import { InboundAppointmentSection as Section } from './InboundAppointmentSection'
import { SectionErrorBoundary } from './SectionErrorBoundary'

export const InboundAppointmentSection = props => (
  <SectionErrorBoundary>
    <Section {...props} />
  </SectionErrorBoundary>
)
